import { Navigate, useParams } from "react-router-dom";

import { WorkspaceTabs } from "../../components/ui/WorkspaceTabs";
import { t } from "../../lib/i18n";
import { URLPoolPage } from "../network/URLPoolPage";
import { RulesPage } from "../rules/RulesPage";
import { SchedulesListPage } from "./schedules/SchedulesListPage";
import { PoliciesGroupsTab } from "./PoliciesGroupsTab";

const TAB_VALUES = ["rules", "domains", "groups", "schedules"] as const;
type PoliciesTab = (typeof TAB_VALUES)[number];

export function PoliciesWorkspace() {
  const { tab } = useParams<{ tab?: string }>();
  const active = (TAB_VALUES as readonly string[]).includes(tab ?? "")
    ? (tab as PoliciesTab)
    : null;

  if (!active) {
    return <Navigate to="/policies/rules" replace />;
  }

  const tabs = TAB_VALUES.map((value) => ({
    value,
    label: t(`policies.tabs.${value}`),
  }));

  return (
    <div className="stack">
      <WorkspaceTabs<PoliciesTab>
        tabs={tabs}
        value={active}
        basePath="/policies"
        ariaLabel={t("policies.workspaceLabel")}
      />
      {active === "rules" && <RulesPage />}
      {active === "domains" && <URLPoolPage />}
      {active === "groups" && <PoliciesGroupsTab />}
      {active === "schedules" && <SchedulesListPage />}
    </div>
  );
}
